import debounce from 'debounce'
import history from 'browserHistory'
import ApolloClient from 'apollo-client'
import * as Sentry from '@sentry/browser'

import {
  getActiveAuthorization,
  getAllAuthorizations,
  removeActiveAuthorization,
} from 'graphql/multisession'

import { routes } from 'constants/routes'
import { signOut } from 'modules/user/useSignOut'
import { trackEvent } from 'modules/analytics'

import store from 'redux/store'
import { actions as toastActions } from 'redux/modules/toasts'

export const debouncedLogoutActiveSession = debounce(
  (
    client: ApolloClient<object>,
    operationName: string,
    message: string,
    reason?: string
  ) => {
    const allAuthorizations = getAllAuthorizations()
    store.dispatch(toastActions.add({ message, variant: 'negative' }))

    const forceLogoutEventProps = reason
      ? { operationName, message, reason }
      : { operationName, message }

    trackEvent(
      'AUTH - invalid active authorization removed',
      forceLogoutEventProps
    )

    const activeAuthorization = getActiveAuthorization(client.cache)
    const sentryBreadcrumbData = {
      active: {
        type: activeAuthorization?.type,
        expirationDateTime: activeAuthorization?.fragment.expirationDateTime,
      },
      // Convert to string as arrays don't seem to be displayed on Sentry breadcrumbs UI
      all: JSON.stringify(
        allAuthorizations.map(auth => ({
          type: auth.type,
          expirationDateTime: auth.fragment.expirationDateTime,
        }))
      ),
    }
    if (allAuthorizations.length <= 1) {
      Sentry.addBreadcrumb({
        category: 'Authentication',
        message: `Force signout`,
        level: Sentry.Severity.Log,
        data: sentryBreadcrumbData,
      })
      trackEvent('AUTH - user forced to logout', forceLogoutEventProps)
      signOut({ client: client, history })
    } else {
      Sentry.addBreadcrumb({
        category: 'Authentication',
        message: `Force auth token removal`,
        level: Sentry.Severity.Log,
        data: sentryBreadcrumbData,
      })
      removeActiveAuthorization(client.cache)
      history.push(routes.ENTRY.create({}))
    }
  },
  100,
  true
)
